import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9358a56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row mb-5 pb-5 justify-content-center" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "row p-0" }
const _hoisted_6 = { class: "col-12 p-0" }
const _hoisted_7 = { class: "card p-3 mb-4 bg-card-crypto border-radius-10 d-block" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Account Type")
  ]),
  /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-12 mt-2" }, " Digital Assets ")
], -1))
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Balance")
], -1))
const _hoisted_12 = { class: "font-white font-size-12 mt-2" }
const _hoisted_13 = { class: "row mt-3" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Name")
], -1))
const _hoisted_16 = { class: "font-white font-size-12 mt-2" }
const _hoisted_17 = {
  class: "col-6",
  style: {"overflow-y":"auto","max-height":"125px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "row mt-3" }
const _hoisted_20 = { class: "col-6 ac-last-first-c" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Reference")
], -1))
const _hoisted_22 = { class: "font-white font-size-12 mt-2" }
const _hoisted_23 = { class: "col-6 ac-last-first-c" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Date Account Established ")
], -1))
const _hoisted_25 = { class: "font-white font-size-12 mt-2" }
const _hoisted_26 = { class: "col-md-8" }
const _hoisted_27 = { class: "p-0 bg-card-crypto border-radius-10" }
const _hoisted_28 = {
  class: "row m-0 bg-card-crypto border-bottom",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-8 d-flex py-4 justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey m-0" }, [
    /*#__PURE__*/_createElementVNode("b", { style: {"color":"#fff"} }, "Transactions"),
    /*#__PURE__*/_createElementVNode("p", {
      class: "font-size-12 font-gray2",
      id: "transSubTitle"
    })
  ])
], -1))
const _hoisted_30 = { class: "col-md-4 d-flex justify-content-start py-4" }
const _hoisted_31 = ["selected", "data-id", "value"]
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"row px-3\" data-v-e9358a56><div class=\"col-md-12 py-3 border-bottom\" data-v-e9358a56><div class=\"row\" data-v-e9358a56><div class=\"col-4\" data-v-e9358a56></div><div class=\"col-2 text-left font-white\" data-v-e9358a56><b data-v-e9358a56>Debit</b></div><div class=\"col-2 text-left font-white\" data-v-e9358a56><b data-v-e9358a56>Credit</b></div><div class=\"col-4 font-white\" data-v-e9358a56><b data-v-e9358a56>Running Balance</b></div></div></div></div>", 1)
const _hoisted_33 = {
  class: "row px-3 transaction-list",
  style: {"height":"600px","overflow-y":"auto"}
}
const _hoisted_34 = ["data-transId", "id"]
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-12" }
const _hoisted_37 = {
  key: 0,
  class: "font-size-16 font-orange1"
}
const _hoisted_38 = {
  key: 1,
  class: "font-size-16 font-orange1"
}
const _hoisted_39 = { class: "font-size-12 font-white m-0" }
const _hoisted_40 = { class: "col-4 d-flex align-items-center" }
const _hoisted_41 = { class: "btn btn-orange pw4 font-size-10 text-uppercase" }
const _hoisted_42 = { class: "font-orange1 font-size-14 m-0" }
const _hoisted_43 = { class: "ml-2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-orange1" }, "+", -1))
const _hoisted_45 = { class: "font-white font-size-14 ml-2" }
const _hoisted_46 = { class: "col-2 text-left font-white font-1-9" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-red" }, "-", -1))
const _hoisted_49 = { class: "col-2 text-left font-white font-1-9" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { style: {"color":"#02FA4E"} }, "+", -1))
const _hoisted_52 = { class: "col-4 d-flex align-items-center justify-content-between font-white" }
const _hoisted_53 = { class: "font-1-9" }
const _hoisted_54 = { class: "col-12" }
const _hoisted_55 = { class: "font-size-12 font-white m-0" }
const _hoisted_56 = {
  key: 0,
  class: "justify-content-center row p-3 transaction-list",
  style: {"height":"auto"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "No Transactions Found", -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "my-4 p-0 bg-white border-radius-10" }
const _hoisted_60 = {
  class: "row m-0",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_61 = { class: "col-md-12 d-flex justify-content-start border-bottom align-items-center py-2" }
const _hoisted_62 = { class: "nav chart-nav justify-content-between" }
const _hoisted_63 = { class: "nav-item" }
const _hoisted_64 = { class: "nav-item" }
const _hoisted_65 = { class: "nav-item" }
const _hoisted_66 = { class: "nav-item" }
const _hoisted_67 = { class: "nav-item" }
const _hoisted_68 = {
  key: 0,
  class: "row"
}
const _hoisted_69 = {
  key: 0,
  class: "col-md-12 mt-4 pt-2 d-flex justify-content-start align-items-center chartDiv",
  id: "lastMonthDiv"
}
const _hoisted_70 = { class: "p-2 mx-auto line-chart" }
const _hoisted_71 = {
  id: "chart1",
  style: {"height":"250px"}
}
const _hoisted_72 = {
  key: 1,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "threeMonthDiv"
}
const _hoisted_73 = { class: "p-2 mx-auto line-chart" }
const _hoisted_74 = {
  id: "chart2",
  style: {"height":"250px"}
}
const _hoisted_75 = {
  key: 2,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "sixMonthDiv"
}
const _hoisted_76 = { class: "p-2 mx-auto line-chart" }
const _hoisted_77 = {
  id: "chart3",
  style: {"height":"250px"}
}
const _hoisted_78 = {
  key: 3,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "yearChartDiv"
}
const _hoisted_79 = { class: "p-2 mx-auto line-chart" }
const _hoisted_80 = {
  id: "chart4",
  style: {"height":"250px"}
}
const _hoisted_81 = {
  key: 4,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "allTimeDiv"
}
const _hoisted_82 = { class: "p-2 mx-auto line-chart" }
const _hoisted_83 = {
  id: "chart5",
  style: {"height":"250px"}
}
const _hoisted_84 = {
  key: 1,
  class: "row"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-md-12 font-grey text-center" }, " Loading...", -1))
const _hoisted_86 = [
  _hoisted_85
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!
  const _component_portfolio_card = _resolveComponent("portfolio-card")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.default_currency) + " " + _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(_ctx.crypto.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.crypto.userac_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subac, (subac) => {
                        return (_openBlock(), _createElementBlock("h5", {
                          class: "font-white font-size-12 mt-2",
                          key: subac.subac_id
                        }, [
                          _createTextVNode(_toDisplayString(subac.subac_name), 1),
                          _hoisted_18,
                          _createTextVNode(" " + _toDisplayString(subac.currency_name) + " " + _toDisplayString(subac.currency_symbol) + _toDisplayString(subac.subac_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("h5", _hoisted_22, " #" + _toDisplayString(_ctx.crypto.userac_reference_code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("h5", _hoisted_25, _toDisplayString(_ctx.crypto.userac_establish_date), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_portfolio_card, {
                default_currency_icon: _ctx.default_currency_icon,
                customer_accounts: _ctx.customer_accounts,
                total_active_default_balance: _ctx.total_active_default_balance
              }, null, 8, ["default_currency_icon", "customer_accounts", "total_active_default_balance"])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("select", {
                    class: "text-right w-100 trans-filter",
                    id: "selected_subac_id",
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterTrans($event)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subac, (subac) => {
                      return (_openBlock(), _createElementBlock("option", {
                        selected: subac.subac_id == _ctx.active_subac,
                        key: subac.subac_id,
                        "data-id": 'subTitle'+subac.subac_id,
                        value: subac.subac_id
                      }, _toDisplayString(subac.subac_name) + " (" + _toDisplayString(subac.currency_name) + ") ", 9, _hoisted_31))
                    }), 128))
                  ], 32)
                ])
              ]),
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (trans) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: trans.trans_id,
                    "data-transId": trans.trans_id,
                    id: 'trans_'+trans.trans_id,
                    class: _normalizeClass([['sub_'+trans.trans_subac_id], "trans_item col-md-12 px-1 py-3 border-bottom"])
                  }, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        (trans.trans_type==1)
                          ? (_openBlock(), _createElementBlock("b", _hoisted_37, _toDisplayString(trans.trans_from_user_id>0 ? 'Transfer to '+ trans.subac_name : 'Transfer'), 1))
                          : _createCommentVNode("", true),
                        (trans.trans_type==2)
                          ? (_openBlock(), _createElementBlock("b", _hoisted_38, _toDisplayString(trans.trans_from_user_id>0 ? 'Deposit from '+trans.user_name : 'Deposit'), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_39, _toDisplayString(trans.trans_description), 1)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("button", _hoisted_41, _toDisplayString(trans.currency_name), 1),
                        _createElementVNode("p", _hoisted_42, [
                          _createElementVNode("span", _hoisted_43, [
                            _hoisted_44,
                            _createTextVNode(" " + _toDisplayString(trans.currency_symbol) + _toDisplayString(trans.trans_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                          ])
                        ]),
                        _createElementVNode("b", _hoisted_45, "rate " + _toDisplayString(trans.trans_usd_rate.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 10})), 1)
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        (trans.trans_type==1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _hoisted_48,
                              _createTextVNode(" " + _toDisplayString(trans.subac_currency_symbol) + " " + _toDisplayString(trans.trans_currency_total.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        (trans.trans_type==2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _hoisted_51,
                              _createTextVNode(" " + _toDisplayString(trans.subac_currency_symbol) + " " + _toDisplayString(trans.trans_currency_total.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("p", _hoisted_53, _toDisplayString(trans.subac_currency_symbol) + " " + _toDisplayString(trans.trans_subac_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("p", _hoisted_55, _toDisplayString(trans.t_time) + "     Transaction ref#" + _toDisplayString(trans.trans_reference_no), 1)
                      ])
                    ])
                  ], 10, _hoisted_34))
                }), 128))
              ]),
              (!_ctx.transactions.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("ul", _hoisted_62, [
                    _createElementVNode("li", _hoisted_63, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (this.active_chart=1)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==1}, "font-grey lastMonth chartBtn"])
                        }, "Last Month", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_64, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (this.active_chart=2)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==2}, "font-grey threeMonth chartBtn"])
                        }, "3M", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_65, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (this.active_chart=3)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==3}, "font-grey sixMonth chartBtn"])
                        }, "6M", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_66, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (this.active_chart=4)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==4}, "font-grey yearChart chartBtn"])
                        }, "Year", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_67, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (this.active_chart=5)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==5}, "font-grey allTime chartBtn"])
                        }, "All", 2)
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.on_chart==1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    (_ctx.active_chart==1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                width: "100%",
                                options: _ctx.chartOptions1,
                                series: _ctx.series1
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions2,
                                series: _ctx.series2
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions3,
                                series: _ctx.series3
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions4,
                                series: _ctx.series4
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("div", _hoisted_83, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions5,
                                series: _ctx.series5
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.on_chart==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, _hoisted_86))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}